<template>
<div class="header">
  <div class="header-main">
    <div class="header-left">
      <img src="../assets/logo.png" alt="">
      <ul class="tabList">
        <li v-for="(item, index) in tabList" :key="index" :class="{active: tabIndex == index}" @click="tabClick(index)">{{item}}</li>
      </ul>
    </div>
    <div class="header-right">
      <div class="user">
        <img src="../assets/header_logo.png" alt="">
        <p>{{ loginUserName }}</p>
      </div>
      <span class="outLogin" @click="outLogin">退出登录</span>
    </div>
  </div>
</div>
</template>

<script>
	import local from '../utils/local.js'
export default {
  name: 'Header',
  data(){
    return {
      tabIndex: 0,
      tabList: ['信息提交', '骑手资源库'],
			loginUserName: ''
    }
  },
	mounted() {
		this.loginUserName = local.get('userInfo').userName
	},
  methods: {
    tabClick(index) {
      this.tabIndex = index
			this.$emit('tabIndexReceive', index)
    },
    // 退出登录
    outLogin(){
      local.remove('userInfo')
			window.location.href = 'https://www.jundakuaidi.com/'
    }
  }
}
</script>

<style scoped>
  .header {
    height: 115px;
    background: #f5f5f5;
    border-bottom: 1px solid #DFDFDF;
  }
  .header-main {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 94px 0 216px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header-left {
    display: flex;
    align-items: center;
  }
  .header-left img {
    width: 100px;
    height: 90px;
    margin-right: 40px;
    cursor: pointer;
  }
  ul,li {
    list-style: none;
  }
  .tabList {
    display: flex;
    height: 100px;
    line-height: 100px;
    position: relative;
    top: 8px;
    cursor: pointer;
  }
  .tabList li {
    width: 140px;
    font-size: 17px;
    color: #9E9E9E;
    text-align: center;
    position: relative;
  }
  .tabList li.active {
    color: #182C80;
  }
  .tabList li.active::after {
    display: block;
    content: '';
    width: 80px;
    height: 3px;
    background: #182C80;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border-radius: 2px;
  }
  .header-right,.user {
    display: flex;
    align-items: center;
  }
  .user img {
    width: 52px;
    height: 52px;
    margin-right: 20px;
  }
  .user p {
    font-size: 17px;
    color: #515151;
  }

  .outLogin {
    margin-left: 50px;
    font-size: 17px;
    color: #ED3636;
    cursor: pointer;
  }
</style>
